import LocalImage from "@common/components/LocalImage";
import { Trans, useTranslation } from "next-i18next";
import { ThrottleTransition, YourNextChapter } from "@public/images";
import { Button, Modal } from "@talladega/components";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const ThrottleTransitionModal = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation(["purchase", "common"]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      alignment="center"
      fitWidthToContent
    >
      <div className="flex ">
        <LocalImage
          src={YourNextChapter}
          className="hidden lg:block"
          alt="Your next chapter with throttle!"
          priority
        />
        <div className="flex flex-col max-w-md items-center justify-center lg:pl-4">
          <div>
            <LocalImage
              src={ThrottleTransition}
              className="mt-5  w-full"
              alt="RightRide to Throttle transition image"
            />
          </div>

          <div>
            <p className="text-primary text-lg pt-6">
              {t("purchase:your_cars_next_chapter_begins_message")}
            </p>
            <p className="text-sm pt-4">
              {t("purchase:autocanada_excited_to_announce_throttle_message")}
            </p>
            <div className="text-sm pt-4">
              <Trans
                t={t}
                i18nKey="purchase:throttle_one_stop_shop_nationwide_message"
                components={{
                  b: <span className="text-sm font-semibold text-primary" />,
                }}
              />
            </div>

            <div className="pt-6">
              <Button
                buttonStyle="primary"
                fill="link"
                onClick={() => onClose()}
                size="small"
                spacing="hug"
                aria-label="Close"
              >
                {t("common:continue")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ThrottleTransitionModal;
